import './Demo.css'
function Demo(){
  function submit(e){
    const formdata=document.querySelector("form")
    e.preventDefault()
    console.log("submitted")
    const realdata= new FormData(formdata)
    fetch("https://script.google.com/macros/s/AKfycbzB44HtGYnBdSbrsS_pvaC70vIz1vc3suwM_s44HdbWrGB4xaz8DvR2BimmyhcWPVTf/exec",{
      method:"POST",
      body:realdata
    })
    alert("sent")
  }
  return(
    <>
    <div className="demo "id="demo">
    <center><h1 id="query_label">Make a Enquiry</h1></center>
    <form className='form' onSubmit={(e)=>submit(e)}>
      <label for="NAME">Name</label>
      <input type="text" placeholder='name' name='NAME' required></input>
       <label for="PHONE_NUMBER">Phone number</label>
      <input type="tel"placeholder='phone number' name='PHONE_NUMBER' pattern='[0-9]{10}'required></input>
       <label for="QUERY">Query</label>
      <input type="text" placeholder='query'name='QUERY'required></input>
      <input type="submit" className='button'  ></input>
    </form>
    </div>
    </>
  )
}

export default Demo;
